<template>
  <div class="customer-page">
    <div class="main">
      <div class="desc-cont">
        <div class="article-section">
          我司与富士康科技集团、长虹集团、海信集团、西南电子电信技术研究所、成都国光电器、中航工业成都飞机设计研究所、中航工业成都飞机发动机设计研究所、四川省投资集团达州燃气电厂、四川省投资集团泸州电厂、中国华电珙县电厂、国家能源集团内江白马电厂、贵州兴义电厂、中国华电塘寨电厂、一汽丰田、玖源化工、拉法基水泥、四川德胜钢铁、四川邮电职业学院、四川仁寿新科综合高中学校、四川华蓥职业技术学校、贵州茅台、五粮液、泸州老窖、中石油西南油气分公司等用户建立了良好的合作关系。
        </div>
      </div>

      <m-base-custom class="cooperative-cont" type="open"></m-base-custom>
    </div>
    <m-base-foot></m-base-foot>
  </div>
</template>

<script>
import MBaseFoot from '../components/MBaseFoot.vue'
import MBaseCustom from '../components/MBaseCustom.vue'

export default {
  name: 'CustomerPage',
  components: {
    MBaseFoot,
    MBaseCustom
  }
}
</script>

<style lang="scss" scoped>
.customer-page {
  background: linear-gradient(180deg, #d3e5f7 0%, #ffffff 30%);
  .main {
    .desc-cont {
      padding: 20px 20px 35px;
      .article-section {
        color: #4c4c4c;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 24px;
        text-indent: 28px;
      }
    }

    .cooperative-cont {
      padding: 0px 20px;
      margin-bottom: 80px;
    }
  }
}
</style>
